import React from "react";
import { cn } from "@/lib/utils";

export const STATUS_COLORS = {
  pending: "bg-amber-500/10 text-amber-300 border-amber-500/20",
  pending_verification: "bg-amber-500/10 text-amber-300 border-amber-500/20",
  approved: "bg-blue-500/10 text-blue-300 border-blue-500/20",
  active: "bg-emerald-500/10 text-emerald-300 border-emerald-500/20",
  rejected: "bg-red-500/10 text-red-300 border-red-500/20",
  need_correction: "bg-orange-500/10 text-orange-300 border-orange-500/20",
  watchlist: "bg-orange-500/10 text-orange-300 border-orange-500/20",
  disqualified: "bg-red-500/10 text-red-300 border-red-500/20",
  bali_qualified: "bg-gradient-to-r from-blue-500/20 to-orange-500/20 text-orange-300 border-orange-500/30",
  pending_bali_audit: "bg-orange-500/10 text-orange-300 border-orange-500/20",
  paid: "bg-emerald-500/10 text-emerald-300 border-emerald-500/20",
  on_hold: "bg-gray-500/10 text-gray-300 border-gray-500/20",
  locked: "bg-gray-700/30 text-gray-400 border-gray-600/40",
  achieved: "bg-blue-500/10 text-blue-300 border-blue-500/20",
  healthy: "bg-emerald-500/10 text-emerald-300 border-emerald-500/20",
  high_risk: "bg-red-500/10 text-red-300 border-red-500/20",
  suspicious: "bg-red-500/10 text-red-300 border-red-500/20",
};

const LABELS = {
  pending_verification: "Pending Verification",
  need_correction: "Need Correction",
  bali_qualified: "Bali Qualified",
  pending_bali_audit: "Pending Bali Audit",
  on_hold: "On Hold",
  high_risk: "High Risk",
};

export default function StatusBadge({ status, className, testId }) {
  const key = status || "neutral";
  const label = LABELS[key] || (key || "").replace(/_/g, " ");
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border capitalize whitespace-nowrap",
        STATUS_COLORS[key] || "bg-gray-500/10 text-gray-300 border-gray-500/20",
        className,
      )}
    >
      {label}
    </span>
  );
}
